import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../shared-components/ng-login/auth/auth.service';
import { Component } from '@angular/core';
import { CustomSnackbarService } from '../../../services/custom-snackbar.service';
import { Customer } from '../../../models/customer';
import { getStorageObject } from '../../../utils/storage-manager';
import { securityDomain } from '../../main/main.component';

@Component({
  selector: 'app-user-forgot-password',
  templateUrl: './user-forgot-password.component.html',
  styleUrls: ['./user-forgot-password.component.scss']
})
export class UserForgotPasswordComponent {
  /**
   * Email reset password form
   */
  public emailResetPasswordForm: FormGroup;

  /**
   * Submitted flag
   */
  public submitted = false;

  protected currentCustomer: Customer | null = getStorageObject('vertical');

  protected readonly securityDomain = securityDomain;

  /**
   * Constructor
   * @param {AuthService} authService Auth service
   * @param snackbarService
   */
  constructor(
    private authService: AuthService,
    public snackbarService: CustomSnackbarService
  ) {
    this.emailResetPasswordForm = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.email, Validators.required]))
    });
  }

  /**
   * Reset password callback function
   */
  resetPassword(): void {
    this.authService.forgotPassword(this.emailResetPasswordForm.get('email')?.value).subscribe(() => {
      this.submitted = true;
      this.snackbarService.present('Please, review your email inbox');
    });
  }
}
